module.exports = __webpack_public_path__ + "static/img/popup-service.8a92641a.png";